import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import DepositLayout from '../../components/updated/Deposit';
import GenericButton from '../../components/updated/shared/Button';
import CustomSelectBox from '../../components/updated/Deposit/CustomSelect';
import PaymentMethodSelection from '../../components/updated/Deposit/SelectPaymentMethod';
import DepositPaymentPopup from '../../components/updated/Deposit/DepositPaymentPopup';
import { useNavigate } from 'react-router-dom';

const useStyle = makeStyles((theme) => ({
  enterAmountRoot: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'stretch',
    justifyContent: 'stretch',
  },
  heading: {
    fontSize: '30px',
    fontWeight: '600',
    color: `${theme.palette.text.primary} !important`,
    textAlign: 'left',
  },
  label: {
    color: `${theme.palette.text.primary} !important`,
    fontSize: '14px',
  },
  warning: {
    color: `${theme.palette.error.main} !important`,
    fontSize: '13px',
  },
}));

const DepositSelectCurrency = () => {
  const classes = useStyle();
  const navigate = useNavigate();

  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [selectedMethod, setSelectedMethod] = useState('');
  const [showWarning, setShowWarning] = useState(false);
  const [pmPopupOpen, setPmPopupOpen] = useState(false);

  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
    setShowWarning(false);
  };

  const handleOpenPmPopup = () => setPmPopupOpen(true);
  const handleClosePmPopup = () => setPmPopupOpen(false);

  const handleSelectPaymentMethod = (method) => {
    setSelectedMethod(method);
    setPmPopupOpen(false);
    setShowWarning(false);
  };

  const handleContinue = () => {
    if (!selectedCurrency || !selectedMethod) {
      setShowWarning(true);
      return;
    }
    navigate('/deposit-enter-amount', {
      state: { currency: selectedCurrency, paymentMethod: selectedMethod },
    });
  };

  return (
    <DepositLayout>
      <div className={classes.enterAmountRoot}>
        <h3 className={classes.heading}>1. Select Currency</h3>

        <h4 className={classes.label}>Currency</h4>
        <CustomSelectBox
          items={['USD']}
          type="Currency"
          onCurrencyChange={handleCurrencyChange}
        />

        <div style={{ margin: 10 }} />

        <h4 className={classes.label}>Deposit with</h4>
        <PaymentMethodSelection
          onClick={handleOpenPmPopup}
          buttonText={selectedMethod || 'Select Transaction Method'}
          type="Deposit"
        />

        <div style={{ margin: 30 }} />

        {showWarning && (
          <div className={classes.warning}>
            {(!selectedCurrency && 'Please select a currency.') ||
              (!selectedMethod && 'Please select a payment method.')}
          </div>
        )}

        <GenericButton
          text="Continue"
          styles={{ marginTop: 'auto' }}
          onClick={handleContinue}
          disabled={!selectedCurrency || !selectedMethod}
        />

        <DepositPaymentPopup
          open={pmPopupOpen}
          onClose={handleClosePmPopup}
          amount={''}
          onSelectPaymentMethod={handleSelectPaymentMethod}
          type="Deposit"
          token={null}
          spendToken={null}
        />
      </div>
    </DepositLayout>
  );
};

export default DepositSelectCurrency;
